<template>
  <v-card>
    <div class="d-flex justify-space-between align-center px-4 py-2">
      <h3 v-text="$t('login.logIn')"></h3>
      <v-btn icon @click="$store.dispatch('navigation/closeLoginView')">
        <v-icon>close</v-icon>
      </v-btn>
    </div>
    <v-divider></v-divider>
    <v-form
      ref="form"
      v-model="valid"
      lazy-validation
      @keyup.native.enter="login()"
      class="pa-4"
    >
      <div class="d-flex flex-column text-center">
        <!-- UsernameInput -->
        <v-text-field
          outlined
          color="primary"
          name="username"
          v-bind:label="$t('login.loginInput')"
          id="username"
          type="text"
          v-model="username"
          :rules="usernameRules"
          required
          clearable
          ref="usernameInput"
          :error-messages="$t(errors.usernameInput)"
          @focus="removeLoginErrorMessage()"
        >
          <template v-slot:append>
            <v-icon color="primary">fas fa-at</v-icon>
          </template>
        </v-text-field>
        <!-- PasswordInput -->

        <v-text-field
          color="primary"
          outlined
          name="password"
          v-bind:label="$t('login.password')"
          id="password"
          type="password"
          v-model="password"
          :rules="passwordRules"
          required
          clearable
          ref="passwordInput"
          :error-messages="$t(errors.passwordInput)"
          @focus="removeLoginErrorMessage()"
        >
          <template v-slot:append>
            <v-icon color="primary">fas fa-lock</v-icon>
          </template>
        </v-text-field>
        <!-- LoginButton -->

        <v-btn
          color="primary"
          class="mb-3"
          large
          block
          @click="login()"
          :disabled="!valid"
          v-html="$t('login.ToLogIn')"
        >
        </v-btn>
        <router-link :to="{ name: 'account/password/reset' }">
          <span
            @click="$store.dispatch('navigation/closeLoginView')"
            v-text="$t('login.lostPassword')"
          >
          </span>
        </router-link>
      </div>
    </v-form>
  </v-card>
</template>

<script>
import ErrorInputMixins from "@/services/ErrorInputMixins";
export default {
  name: "TheAccountLoginModal",
  mixins: [ErrorInputMixins],
  data() {
    return {
      usernameRules: [
        v => !!v || this.$i18n.t("login.rules.username.required")
      ],
      passwordRules: [
        v => !!v || this.$i18n.t("login.rules.password.required")
      ],
      username: "",
      password: "",
      valid: true,
      incorrectCredentials: false,
      notFound: false
    };
  },

  methods: {
    login() {
      if (this.$refs.form.validate()) {
        this.$store
          .dispatch("account/myAccount", {
            username: this.username,
            password: this.password
          })
          .then(() => {
            this.$store.dispatch("navigation/closeLoginView");
          })
          .catch(alert => {
            this.triggerInputAlert(alert);
          });
      }
    },
    removeLoginErrorMessage() {
      this.removeInputErrorMessage("usernameInput");
      this.removeInputErrorMessage("passwordInput");
    }
  }
};
</script>
